import { makeAutoObservable, runInAction } from 'mobx';
import {
  IShopForMap,
  IShopInfo,
  IShopParams,
  IShopReportParam,
  ShopLocation,
  ShopReportData,
} from 'src/@types/Choqorak/MainTables/Shop/Shop';
import agent from 'src/api/agent';
export default class ShopStore {
  openDialog = false;

  ShopRegistry = new Map<number, IShopInfo>();

  editMode = false; //When click on edit button

  selectedShop: IShopInfo | undefined = undefined;

  totalRecord: number = 0;

  ShopReportResult: ShopReportData | undefined;

  ShopForMapResult: IShopForMap[] | undefined;

  selectedShopDetail: IShopInfo | undefined;

  ID: any = localStorage.getItem('id');

  constructor() {
    makeAutoObservable(this);
  }

  get ShopList() {
    return Array.from(this.ShopRegistry.values());
  }

  setShopList = (Shop: IShopInfo) => {
    this.ShopRegistry.set(Shop.shopId!, Shop);
  };

  //Pagination
  loadShop = async (params: IShopParams) => {
    // this.ShopRegistry.clear();
    try {
      const result = await agent.Shop.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setShopList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  ShopSearch = async (params: IShopParams) => {
    this.ShopRegistry.clear();
    this.loadShop(params);
  };

  getShopFromRegistry = (id: number) => {
    let Shop = this.ShopRegistry.get(id);
    if (Shop) {
      this.editMode = true;
      this.selectedShop = Shop;
    }
  };

  clearSelectedShop = () => {
    this.editMode = false;
    this.selectedShop = undefined;
    this.selectedShopDetail = undefined;
  };

  deleteShop = async (id: number, remark?: string) => {
    try {
      await agent.Shop.delete(id, remark!);
      runInAction(() => {
        this.ShopRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    } catch (error) {
      console.log(error);
    }
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createShop = async (Shop: IShopInfo) => {
    await agent.Shop.create(Shop);
    runInAction(() => {
      this.loadShop({ pageIndex: 0, pageSize: 5 });
      this.clearSelectedShop();
    });
  };

  updateShop = async (Shop: IShopInfo) => {
    await agent.Shop.update(Shop);

    runInAction(() => {
      this.loadShop({ pageIndex: 0, pageSize: 5 });
      this.ShopRegistry.delete(Shop.shopId!);
      this.ShopRegistry.set(Shop.shopId!, Shop);
      this.clearSelectedShop();
    });
  };

  updateShopLocation = async (Shop: ShopLocation) => {
    await agent.Shop.updateShopLocation(Shop);

    runInAction(() => {});
  };

  loadShopDetail = async (id?: number) => {
    try {
      const getShopDetail = await agent.Shop.getDetail(id);
      runInAction(() => {
        this.editMode = true;
        this.selectedShopDetail = getShopDetail;
      });
    } catch (error) {}
  };

  loadShopReport = async (reportParams: IShopReportParam) => {
    console.log(reportParams);
    const axiosResponse = await agent.Shop.getShopReport(reportParams);

    runInAction(() => {
      this.ShopReportResult = axiosResponse.data;
    });
  };

  loadShopForMap = async (reportParams: IShopReportParam) => {
    const axiosResponse = await agent.Shop.getShopForMap(reportParams);

    runInAction(() => {
      this.ShopForMapResult = axiosResponse.data;
    });
  };
}
